import DefaultMainPage from "../../pages/DefaultMainPage";
import Cs from "./Cs";
import MacroManager from "./MacroManager";

const csMenuItems = [
    {path: "/cs", component: <Cs/>, label: '고객센터'},
    {path: "/cs/macro", component: <MacroManager/>, label: '템플릿 관리'},
];

export const csRoutes = {
    path: "/cs",
    component: <DefaultMainPage buttons={csMenuItems}/>,
    children: csMenuItems
};